import React, { useState, useEffect, Fragment } from 'react';
import { Button } from 'reactstrap';

const SMSConfig = ({ SMSEnabled, handlerChangeSMSConfig }) => {

    useEffect(() => {

    }, []);

    const enableSMS = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'parametrizacion-sms/habilitar', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ activacion: !SMSEnabled })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                if (SMSEnabled) {
                    alert("SMS Deshabilitado correctamente");
                }
                else {
                    alert("SMS Habilitado correctamente");
                }
                handlerChangeSMSConfig(!SMSEnabled);
            }
            else {
                alert("Ha ocurrido un error configurando los SMS");
            }
        }).catch(err => {
            console.log(err);
        })
    }

    return (<Fragment>
        <div className="card__title">
            <h5 className="bold-text">Configuración de SMS</h5>
            <h5 className="subhead">Al Habilitar o deshabilitar los SMS afectara los Mensajes de Texto que se utilizan en el sistema.</h5>
        </div>
        <Button
            style={{ marginTop: 20 }}
            color="primary"
            onClick={() => {
                enableSMS();
            }}
        >
            {!SMSEnabled ? "Habilitar" : "Deshabilitar"}
        </Button>
    </Fragment>)
};

export default SMSConfig;